export function useMyFetch(url, options = {}) {
  const config = useRuntimeConfig()

  const res = useLazyFetch(url, {
    ...options,
    baseURL: config.public.baseApi,
    lazy: options.lazy || true,
    default: () => ({}),
    onRequest({ options }) {
      options.headers = options.headers || {}
    }
  })
  watch(
    () => res.error.value,
    (val) => {
      if (val) {
        showErrorMessage('服务器升级中')
      }
    }
  )
  watch(
    () => res.data.value,
    (val) => {
      if (val.code != 0) {
        showErrorMessage(val.msg ?? '系统升级中，请稍后再试~')
      }
    }
  )

  const data = computed(() => res.data.value.data)
  return {
    ...res,
    data
  }
}

const showErrorMessage = (msg) => {
  // const { message } = useMessage()
  // message.error(msg)
}
